import { Table, Button, ButtonGroup } from "react-bootstrap";
import { FoodLogType } from "../../DTO";
import { convertToPDTByLibrary } from "../../utils";
import { useAppNavigate } from "../../Router/hook";

type Props = {
    items: FoodLogType[];
    onViewItems: (item: FoodLogType) => void;
    userId?: number;
};

export const FoodLogTable = ({ items, onViewItems, userId }: Props) => {
    const navigate = useAppNavigate();

    const handleViewDailySummary = (dailyTaskId?: number, dayId?: number) => {
        console.log("Summary click:", { dailyTaskId, dayId, userId });
        if (!userId) {
            console.warn("userId is not available");
            return;
        }
        // استفاده از daily_task_id اگر موجود است، در غیر این صورت day_id
        const summaryId = dailyTaskId || dayId;
        if (!summaryId) {
            console.warn("neither daily_task_id nor day_id available");
            return;
        }
        navigate(`/app-user/${userId}/food-summary/daily/${summaryId}`);
    };

    return (
        <Table hover responsive className="align-middle">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Calories</th>
                    <th>Protein</th>
                    <th>Carbs</th>
                    <th>Fat</th>
                    <th>Duration</th>
                    <th>Date</th>
                    <th>Score</th>
                    <th style={{ width: 200 }}>Actions</th>
                </tr>
            </thead>

            <tbody>
                {items.map((item) => (
                    <tr key={item.id}>
                        <td>
                            <strong>🍽 {item.type}</strong>
                        </td>

                        <td>🔥 {item.total_nutrition?.calories ?? 0}</td>
                        <td>{item.total_nutrition?.protein ?? 0}g</td>
                        <td>{item.total_nutrition?.carbohydrates ?? 0}g</td>
                        <td>{item.total_nutrition?.fat ?? 0}g</td>

                        <td>🕒 {item.duration_time} min</td>

                        <td>{convertToPDTByLibrary(item.created_at)}</td>

                        <td>
                            {item.traffic_light ? (
                                <span
                                    className="px-3 py-1 rounded-pill text-white fw-semibold"
                                    style={{
                                        backgroundColor:
                                            item.traffic_light.overall
                                                .color_code,
                                        fontSize: 12,
                                    }}
                                >
                                    {item.traffic_light.overall.light.toUpperCase()}{" "}
                                    •{" "}
                                    {item.traffic_light.overall.score ??
                                        "Pending"}
                                </span>
                            ) : (
                                "-"
                            )}
                            {["stale", "pending"].includes(
                                item.traffic_light?.assessment_state || "",
                            ) && (
                                <small className="d-block text-warning mt-1">
                                    Score updating
                                </small>
                            )}
                        </td>

                        <td>
                            <ButtonGroup size="sm" className="d-flex gap-2">
                                <Button
                                    variant="outline-primary"
                                    onClick={() => onViewItems(item)}
                                    title="View meal items"
                                >
                                    📋 Items
                                </Button>
                                {userId && (
                                    <Button
                                        variant="outline-success"
                                        onClick={() =>
                                            handleViewDailySummary(
                                                item.daily_task_id,
                                                item.day_id,
                                            )
                                        }
                                        title="View daily summary"
                                    >
                                        📊 Summary
                                    </Button>
                                )}
                            </ButtonGroup>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};
